export const FETCH_TUTOR_LIST = 'FETCH_TUTOR_LIST';
export const RESET_TUTOR_LIST = 'RESET_TUTOR_LIST';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
